module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col text-right dashboard-header__actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('tour')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-compass"
  }), _vm._v(" Take a tour\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-xl-3"
  }, [_c('h2', [_vm._v("\n      Smart Segmentation\n      "), _c('span', {
    staticClass: "targeting-badge"
  }, [_vm._v("+Targeting")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6b19882","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/segmentation/partials/DashboardHeader.vue
// module id = 3411
// module chunks = 3